import { useEffect, useRef } from "react";
import { isNil } from 'lodash';

const EffectOnceManager = (() => {
    let instance;

    const createInstance = () => {
        const renderedMap = new Map();

        return {
            execute: (callback, dependencies, componentId) => {
                if (renderedMap.get(componentId) || dependencies.some(isNil)) {
                    return;
                }

                callback();
                renderedMap.set(componentId, true);
            },
            reset: (componentId) => {
                renderedMap.delete(componentId);
            }
        };
    };

    return {
        getInstance: () => {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        }
    };
})();

const useEffectOnce = (callback, dependencies) => {
    const componentId = useRef(Symbol('effectOnceComponentId')).current;
    const manager = EffectOnceManager.getInstance();

    useEffect(() => {
        manager.execute(callback, dependencies, componentId);

        return () => {
            manager.reset(componentId);
        };
    }, [dependencies]);
};

export default useEffectOnce;
